import { i18n } from 'i18n'

function getColorTranslation(color: string): string {
  const simple = color.toLowerCase()
    .replaceAll('ё', 'е')
    .replaceAll('grey', 'gray')
    .replaceAll(/\s/g, ' ').trim()
  switch (simple) {
    case 'beige':
    case 'бежевый':
      return i18n('ColorBeige')
    case 'white':
    case 'белый':
      return i18n('ColorWhite')
    case 'colorless':
    case 'бесцветный':
      return i18n('ColorColorless')
    case 'turquoise':
    case 'бирюзовый':
      return i18n('ColorTurquoise')
    case 'burgundy':
    case 'бордовый':
      return i18n('ColorBurgundy')
    case 'bronze':
    case 'бронзовый':
      return i18n('ColorBronze')
    case 'lightblue':
    case 'голубой':
      return i18n('ColorLightBlue')
    case 'mustard':
    case 'горчичный':
      return i18n('ColorMustard')
    case 'yellow':
    case 'желтый':
      return i18n('ColorYellow')
    case 'green':
    case 'зеленый':
      return i18n('ColorGreen')
    case 'golden':
    case 'золотой':
      return i18n('ColorGolden')
    case 'coral':
    case 'коралловый':
      return i18n('ColorCoral')
    case 'brown':
    case 'коричневый':
      return i18n('ColorBrown')
    case 'red':
    case 'красный':
      return i18n('ColorRed')
    case 'cream':
    case 'кремовый':
      return i18n('ColorCream')
    case 'leopard':
    case 'леопардовый':
      return i18n('ColorLeopard')
    case 'crimson':
    case 'малиновый':
      return i18n('ColorCrimson')
    case 'copper':
    case 'медный':
      return i18n('ColorCopper')
    case 'milky':
    case 'молочный':
      return i18n('ColorMilky')
    case 'orange':
    case 'оранжевый':
      return i18n('ColorOrange')
    case 'transparent':
    case 'прозрачный':
      return i18n('ColorTransparent')
    case 'multicolored':
    case 'разноцветный':
      return i18n('ColorMulticolor')
    case 'pink':
    case 'розовый':
      return i18n('ColorPink')
    case 'limegreen':
    case 'салатовый':
      return i18n('ColorLimeGreen')
    case 'light beige':
    case 'светло-бежевый':
      return i18n('ColorLightBeige')
    case 'pale blue':
    case 'светло-голубой':
      return i18n('ColorPaleBlue')
    case 'light yellow':
    case 'светло-желтый':
      return i18n('ColorLightYellow')
    case 'light green':
    case 'светло-зеленый':
      return i18n('ColorLightGreen')
    case 'light brown':
    case 'светло-коричневый':
      return i18n('ColorLightBrown')
    case 'light pink':
    case 'светло-розовый':
      return i18n('ColorLightPink')
    case 'skyblue':
    case 'светло-синий':
      return i18n('ColorSkyBlue')
    case 'light lilac':
    case 'светло-сиреневый':
      return i18n('ColorLightLilac')
    case 'light gray':
    case 'светло-серый':
      return i18n('ColorLightGray')
    case 'light purple':
    case 'светло-фиолетовый':
      return i18n('ColorLightPurple')
    case 'silver':
    case 'серебряный':
      return i18n('ColorSilver')
    case 'gray blue':
    case 'серо-голубой':
      return i18n('ColorGrayBlue')
    case 'gray':
    case 'серый':
      return i18n('ColorGray')
    case 'blue':
    case 'синий':
      return i18n('ColorBlue')
    case 'lilac':
    case 'сиреневый':
      return i18n('ColorLilac')
    case 'dark beige':
    case 'темно-бежевый':
      return i18n('ColorDarkBeige')
    case 'dark turquoise':
    case 'темно-бирюзовый':
      return i18n('ColorDarkTurquoise')
    case 'dark burgundy':
    case 'темно-бордовый':
      return i18n('ColorDarkBurgundy')
    case 'dark blue':
    case 'темно-голубой':
      return i18n('ColorDarkBlue')
    case 'dark green':
    case 'темно-зеленый':
      return i18n('ColorDarkGreen')
    case 'dark yellow':
    case 'темно-желтый':
      return i18n('ColorDarkYellow')
    case 'dark brown':
    case 'темно-коричневый':
      return i18n('ColorDarkBrown')
    case 'dark pink':
    case 'темно-розовый':
      return i18n('ColorDarkPink')
    case 'navy blue':
    case 'темно-синий':
      return i18n('ColorIndigo')
    case 'dark gray':
    case 'темно-серый':
      return i18n('ColorDarkGray')
    case 'dark purple':
    case 'темно-фиолетовый':
      return i18n('ColorDarkPurple')
    case 'terracotta':
    case 'терракотовый':
      return i18n('ColorTerracotta')
    case 'purple':
    case 'фиолетовый':
      return i18n('ColorPurple')
    case 'fuchsia':
    case 'фуксия':
      return i18n('ColorFuchsia')
    case 'khaki':
    case 'хаки':
      return i18n('ColorKhaki')
    case 'black/white':
    case 'черно-белый':
      return i18n('ColorBlackAndWhite')
    case 'black':
    case 'черный':
      return i18n('ColorBlack')
    default:
      return color
  }
}

function getCategoryTranslation(category: string): string {
  switch (category.toLowerCase()) {
    // BOTTOMS
    case 'юбки':
      return i18n('CategorySkirts')
    case 'брюки':
      return i18n('CategoryTrousers')
    case 'джинсы':
      return i18n('CategoryJeans')
    case 'кюлоты':
      return i18n('CategoryCulottes')
    case 'легинсы':
      return i18n('CategoryLeggings')
    case 'шорты':
      return i18n('CategoryShorts')
    // TOPS
    case 'блузы':
      return i18n('CategoryBlouses')
    case 'боди':
      return i18n('CategoryBodysuits')
    case 'жакеты':
      return i18n('CategoryJackets')
    case 'кардиганы':
    case 'джемперы':
      return i18n('CategoryCardigans')
    case 'водолазки':
      return i18n('CategoryTurtlenecks')
    case 'жакеты и костюмы':
      return i18n('CategoryJacketsAndSuits')
    case 'жилеты':
      return i18n('CategoryVests')
    case 'накидки':
    case 'кейпы и накидки':
      return i18n('CategoryCapes')
    case 'топы':
      return i18n('CategoryTops')
    case 'толстовки':
      return i18n('CategoryHoodies')
    case 'поло':
      return i18n('CategoryPolo')
    case 'трикотаж':
      return i18n('CategoryKnitwear')
    case 'туники':
      return i18n('CategoryTunics')
    case 'футболки и топы':
      return i18n('CategoryTShirtsAndTops')
    case 'майки':
      return i18n('CategoryAShirts')
    case 'футболки':
      return i18n('CategoryTShirts')
    case 'пиджаки':
      return i18n('CategoryJacketsMen')
    case 'рубашки':
      return i18n('CategoryShirts')
    case 'свитеры':
      return i18n('CategorySweaters')
    case 'свитшоты':
      return i18n('CategorySweatshirts')
    // OUTWEAR
    case 'бомберы':
      return i18n('CategoryBombers')
    case 'верхняя одежда':
      return i18n('CategoryOuterwear')
    case 'дублёнки':
      return i18n('CategorySheepskinCoats')
    case 'пальто':
      return i18n('CategoryCoats')
    case 'пальто и плащи':
      return i18n('CategoryCoatsAndRaincoats')
    case 'парки':
      return i18n('CategoryParkas')
    case 'плащи':
      return i18n('CategoryRaincoats')
    case 'пуховики':
      return i18n('CategoryDownJackets')
    case 'тренчкоты':
      return i18n('CategoryTrenchCoats')
    case 'шубы':
      return i18n('CategoryFurCoats')
    case 'шубы и дублёнки':
      return i18n('CategoryFurSheepskinCoats')
    // OTHERS
    case 'комбинезоны':
      return i18n('CategoryJumpsuits')
    case 'костюмы':
      return i18n('CategorySuits')
    case 'корсеты':
      return i18n('CategoryCorsets')
    case 'платья':
      return i18n('CategoryDresses')
    case 'домашняя одежда':
      return i18n('CategoryHome')
    case 'слитные купальники':
      return i18n('CategoryOnePieceSwimsuit')
    case 'плавки':
      return i18n('CategorySwimmingTrunks')
    default:
      return category
  }
}

export function getTranslation(type: string, value: string): string {
  switch (type) {
    case 'colors':
      return getColorTranslation(value)
    case 'categories':
      return getCategoryTranslation(value)
    default:
      return value
  }
}

export function getCategoryGroupTranslation(group: string): string {
  switch (group) {
    case 'Женское > Винтаж > Одежда':
      return i18n('FemaleVintage')
    case 'Женское > Одежда > Бельё':
      return i18n('FemaleLingerie')
    case 'Женское > Одежда':
      return i18n('FemaleClothing')
    case 'Женское > Одежда > Верхняя одежда':
      return i18n('FemaleOuterwear')
    case 'Женское > Одежда > Спорт':
      return i18n('FemaleSport')
    case 'Женское > Одежда > Пляжная одежда > Купальники':
      return i18n('FemaleSwimwear')
    case 'Мужское > Одежда > Бельё и домашняя одежда':
      return i18n('MaleUnderwear')
    case 'Мужское > Одежда > Верхняя одежда':
      return i18n('MaleOuterwear')
    case 'Мужское > Одежда':
      return i18n('MaleClothing')
    case 'Мужское > Одежда > Спорт':
      return i18n('MaleClothingSport')
    case 'Мужское > Одежда >  Пляжные принадлежности':
      return i18n('MaleBeach')
    default:
      return group
  }
}
